import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "33660235665";

export default function WhatsAppButton() {
  const { t } = useTranslation();
  const message = encodeURIComponent("Bonjour JobVinum, j'ai besoin d'aide");
  const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

  const handleClick = (e) => {
    // Force a genuine top-level new browsing context (more reliable than relying
    // solely on target="_blank" when the app is rendered inside an embedding frame).
    e.preventDefault();
    const win = window.open(link, "_blank", "noopener,noreferrer");
    if (!win) {
      // Popup blocked: fall back to a same-tab navigation so the link still works.
      window.location.href = link;
    }
  };

  return (
    <a
      href={link}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 flex items-center gap-2 bg-[#34C759] text-white h-14 w-14 sm:w-auto sm:px-5 rounded-full shadow-[0_12px_48px_rgba(52,199,89,0.3)] hover:scale-105 transition-transform justify-center"
      data-testid="whatsapp-support-button"
      aria-label={t("common.whatsappSupport")}
    >
      <MessageCircle className="h-6 w-6 shrink-0" fill="currentColor" />
      <span className="hidden sm:inline font-semibold text-sm">{t("common.whatsappSupport")}</span>
    </a>
  );
}
